var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M16,18.8V9.2c0-0.6,0.4-1,1-1s1,0.4,1,1v9.6l2.5-2.5c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-3.5,3.5 c-0.8,0.8-2,0.8-2.8,0l-3.5-3.5c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0L16,18.8z M6,5.2L3.5,7.7c-0.4,0.4-1,0.4-1.4,0 c-0.4-0.4-0.4-1,0-1.4l3.5-3.5c0.8-0.8,2-0.8,2.8,0l3.5,3.5c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0L8,5.2v9.6c0,0.6-0.4,1-1,1 s-1-0.4-1-1V5.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.d4b852972b3ebd08b6ccfe955ebb583c.svg";
export { ForwardRef as ReactComponent };